import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the accounts and factoring api
 */
export class CityXReferenceService extends BaseService {

	constructor() {	
		super();
	}
	
	async getCityXRefs(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/cityxrefs' + params);		
		return data;		
	}
	
	async getCityXRef(id) {
		var data = await this.makeGETRequest('/api/resource/cityxrefs/' + id);		
		return data;		
	}
	
	async saveCityXRef(cityxrefs, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/cityxrefs/' + cityxrefs.cityXrefId, cityxrefs);
		} else {
			saved = await this.makePOSTRequest('/api/resource/cityxrefs', cityxrefs);
		}
		return saved;		
	}	
	
	async deleteCityXReferences(ids) {
		var data = await this.makeDELETERequest('/api/resource/cityxrefs', ids);		
		return data;		
	}
	
	async deleteAllCityXReferences(companyId) {
		var endPart = '';
		if (companyId) {
			endPart = '?companyId=' + companyId;
		}
		var data = await this.makeDELETERequest('/api/resource/cityxrefs/all' + endPart);		
		return data;		
	}	
	
	exportCityXReferences(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/cityxrefs/export' + params);		
	};	
	
}


